import React from 'react';
import './Loader.css'; // You'll need to style the loader

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;